module.exports = __webpack_public_path__ + "static/hero-border-red-cb79b3f27b8368d4f0ea2e758a0e65ee.svg";